<div class="flex space-x-3 items-center">
    <slot name="icon" />
    <slot />
</div>
  